import { ReactNode } from "react"

export type BasePageType = {
    nopadding?: string
    children: ReactNode
    classProps?: string
}

export default function BasePage({ children, nopadding, classProps }: BasePageType) {
    return <section className={`w-full h-full overflow-hidden text-black flex flex-col ${nopadding ?? "p-4"} ${classProps ?? ""}`}>{children}</section>
}
